import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { 
  CanalesAtencionRequest, 
  CanalesAtencionResponse 
} from '../../models/canales-atencion/canales-atencion.model';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CanalesAtencionService {
  private readonly apiUrl =  `${ENV.HOST}${URL_MAP.API.COTIZADOR_CANALES_ATENCION}`;

  constructor(private httpClient: HttpClient) { }

  /**
   * Consulta los canales de atención disponibles
   * @returns Observable con la lista de canales de atención
   */
  getCanalesAtencion(): Observable<CanalesAtencionResponse> {
    const requestBody: CanalesAtencionRequest = {
      nombreClave: 'getCanalesAtencionAfilmed',
      jsonParametros: '{}'
    };

    return this.httpClient.post<CanalesAtencionResponse>(this.apiUrl, requestBody).pipe(
      map((response: CanalesAtencionResponse) => response),
      catchError(error => {
        let errorMessage: string;
        if (error.status === 404) {
          errorMessage = 'No se encontró el recurso de canales de atención.';
        } else if (error.status === 500) {
          errorMessage = 'Error en el servidor al obtener canales de atención.';
        } else {
          errorMessage = error.error?.message || 'Error al consultar canales de atención.';
        }
        console.error('Error en getCanalesAtencion:', error);
        return throwError(() => errorMessage);
      })
    );
  }
}
